// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldCarousel = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 16 15',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.0937 0.015625H2.65625C1.72427 0.015625 0.96875 0.771145 0.96875 1.70313V9.85938C0.96875 10.7914 1.72427 11.5469 2.65625 11.5469H11.0937C12.0257 11.5469 12.7812 10.7914 12.7812 9.85938V1.70313C12.7812 0.771145 12.0257 0.015625 11.0937 0.015625Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.905 2.84375C14.3156 2.87188 14.5237 2.93937 14.7319 3.05187C15.0019 3.19812 15.2212 3.4175 15.3675 3.6875C15.5137 3.96875 15.5925 4.23875 15.5925 4.9925V11.9113C15.5925 12.665 15.5137 12.9406 15.3675 13.2163C15.2219 13.4854 15.001 13.7062 14.7319 13.8519C14.4506 13.9981 14.1806 14.0769 13.4269 14.0769H5.94562C5.19187 14.0769 4.91625 13.9981 4.64062 13.8519C4.37009 13.7081 4.14873 13.4868 4.005 13.2163C3.8925 13.0081 3.825 12.8 3.79688 12.3894H11.0194C12.0262 12.3894 12.3862 12.2825 12.7519 12.0913C13.1167 11.8991 13.4147 11.601 13.6069 11.2363C13.7981 10.8706 13.905 10.505 13.905 9.50375V2.84375Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldCarousel };
